"use client";

import { c as _c } from "react/compiler-runtime";
import { ArrowRight, ChevronDown, MapPin } from "lucide-react";
import { useLocale, useTranslations } from "next-intl";
import NextImage from "next/image";
export function Hero() {
  const $ = _c(66);
  const t = useTranslations("hero");
  const locale = useLocale();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="absolute inset-0 opacity-10"><div className="absolute top-20 left-10 w-72 h-72 bg-forest-green rounded-full blur-3xl" /><div className="absolute bottom-20 right-10 w-96 h-96 bg-terracotta rounded-full blur-3xl" /><div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-wood-natural rounded-full blur-3xl opacity-30" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("tagline");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <p className="text-terracotta font-medium mb-4 tracking-wider uppercase text-sm">{t1}</p>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("title");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif text-forest-green leading-tight mb-6">{t3}</h1>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("description");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <p className="max-w-xl text-lg leading-relaxed text-wood-natural mb-6">{t5}</p>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <MapPin className="w-5 h-5" />;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t) {
    t8 = t("location");
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t8) {
    t9 = <div className="flex items-center gap-2 text-wood-natural mb-8">{t7}<span className="text-lg">{t8}</span></div>;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  const t10 = `/${locale}#contact`;
  let t11;
  if ($[18] !== t) {
    t11 = t("cta.primary");
    $[18] = t;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <ArrowRight className="w-5 h-5" />;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t10 || $[22] !== t11) {
    t13 = <a href={t10} className="btn-primary inline-flex items-center gap-2">{t11}{t12}</a>;
    $[21] = t10;
    $[22] = t11;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  const t14 = `/${locale}#prestations`;
  let t15;
  if ($[24] !== t) {
    t15 = t("cta.secondary");
    $[24] = t;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t14 || $[27] !== t15) {
    t16 = <a href={t14} className="btn-secondary inline-flex items-center gap-2">{t15}</a>;
    $[26] = t14;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t13 || $[30] !== t16) {
    t17 = <div className="flex flex-wrap gap-4">{t13}{t16}</div>;
    $[29] = t13;
    $[30] = t16;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== t17 || $[33] !== t2 || $[34] !== t4 || $[35] !== t6 || $[36] !== t9) {
    t18 = <div className="fade-in-up visible">{t2}{t4}{t6}{t9}{t17}</div>;
    $[32] = t17;
    $[33] = t2;
    $[34] = t4;
    $[35] = t6;
    $[36] = t9;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== t) {
    t19 = t("imageAlt");
    $[38] = t;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== t19) {
    t20 = <NextImage src="/images/portfolio/architecture-interior.jpg" alt={t19} fill={true} fetchPriority="high" priority={true} sizes="(max-width: 1024px) 100vw, 50vw" />;
    $[40] = t19;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <div className="absolute inset-0 bg-gradient-to-t from-charcoal/30 via-transparent to-transparent" />;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  let t22;
  if ($[43] !== t20) {
    t22 = <div className="rounded-2xl aspect-[3/4] overflow-hidden shadow-2xl relative">{t20}{t21}</div>;
    $[43] = t20;
    $[44] = t22;
  } else {
    t22 = $[44];
  }
  let t23;
  if ($[45] !== t) {
    t23 = t("badge.years");
    $[45] = t;
    $[46] = t23;
  } else {
    t23 = $[46];
  }
  let t24;
  if ($[47] !== t23) {
    t24 = <p className="text-forest-green font-semibold text-sm">{t23}</p>;
    $[47] = t23;
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  let t25;
  if ($[49] !== t) {
    t25 = t("badge.experience");
    $[49] = t;
    $[50] = t25;
  } else {
    t25 = $[50];
  }
  let t26;
  if ($[51] !== t25) {
    t26 = <p className="text-wood-natural text-xs">{t25}</p>;
    $[51] = t25;
    $[52] = t26;
  } else {
    t26 = $[52];
  }
  let t27;
  if ($[53] !== t24 || $[54] !== t26) {
    t27 = <div className="absolute -bottom-4 -left-4 bg-white-cream rounded-xl p-4 shadow-xl">{t24}{t26}</div>;
    $[53] = t24;
    $[54] = t26;
    $[55] = t27;
  } else {
    t27 = $[55];
  }
  let t28;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <div className="absolute -top-4 -right-4 w-full h-full border-2 border-terracotta/30 rounded-2xl -z-10" />;
    $[56] = t28;
  } else {
    t28 = $[56];
  }
  let t29;
  if ($[57] !== t22 || $[58] !== t27) {
    t29 = <div className="visible"><div className="relative">{t22}{t27}{t28}</div></div>;
    $[57] = t22;
    $[58] = t27;
    $[59] = t29;
  } else {
    t29 = $[59];
  }
  let t30;
  if ($[60] !== t18 || $[61] !== t29) {
    t30 = <div className="grid lg:grid-cols-2 gap-12 items-center">{t18}{t29}</div>;
    $[60] = t18;
    $[61] = t29;
    $[62] = t30;
  } else {
    t30 = $[62];
  }
  let t31;
  if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce"><ChevronDown className="w-8 h-8 text-forest-green/50" /></div>;
    $[63] = t31;
  } else {
    t31 = $[63];
  }
  let t32;
  if ($[64] !== t30) {
    t32 = <section className="min-h-screen flex items-center justify-center relative overflow-hidden bg-sand-light">{t0}<div className="max-w-7xl mx-auto px-6 pt-24 pb-12 relative z-10">{t30}{t31}</div></section>;
    $[64] = t30;
    $[65] = t32;
  } else {
    t32 = $[65];
  }
  return t32;
}